import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '仪表盘', icon: 'dashboard'}
    }
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/member',
    name: 'user',
    meta: {title: '会员', icon: 'ums-member'},
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/ums/member/index'),
        meta: {title: '会员列表', icon: 'ums-member'}
      },
      {
        path: 'memberLoginLog',
        component: () => import('@/views/base/memberLoginLog/index.vue'),
        name: 'memberLoginLog',
        meta: {title: '会员登录日志'}
      },
      {
        path: 'helpFeedback',
        component: () => import('@/views/ums/helpFeedback/index.vue'),
        name: 'helpFeedback',
        meta: {title: '反馈列表', icon: 'cms-feedback'}
      },
      {
        path: 'helpFeedback/view',
        component: () => import('@/views/ums/helpFeedback/view.vue'),
        name: 'helpFeedbackView',
        meta: {title: '查看反馈'},
        hidden: true
      },
      {
        path: 'helpFeedback/edit',
        component: () => import('@/views/ums/helpFeedback/edit.vue'),
        name: 'helpFeedbackEdit',
        meta: {title: '编辑反馈'},
        hidden: true
      },
      {
        path: 'recruitment',
        component: () => import('@/views/base/recruitment/index.vue'),
        name: 'recruitment',
        meta: {title: '招聘管理'}
      },
      {
        path: 'jobCase',
        component: () => import('@/views/cms/jobCase/index.vue'),
        name: 'jobCase',
        meta: {title: '就业案例', icon: 'cms-job-case'}
      },
      {
        path: 'jobCase/add',
        component: () => import('@/views/cms/jobCase/add.vue'),
        name: 'JobCaseAdd',
        meta: {title: '添加就业案例'},
        hidden: true
      },
      {
        path: 'jobCase/edit',
        component: () => import('@/views/cms/jobCase/edit.vue'),
        name: 'JobCaseEdit',
        meta: {title: '编辑就业案例'},
        hidden: true
      },
      {
        path: 'policyInterpretation',
        component: () => import('@/views/cms/policyInterpretation/index.vue'),
        name: 'policyInterpretation',
        meta: {title: '政策解读', icon: 'cms-policy'}
      },
      {
        path: 'policyInterpretation/add',
        component: () => import('@/views/cms/policyInterpretation/edit.vue'),
        name: 'PolicyInterpretationAdd',
        meta: {title: '添加政策解读'},
        hidden: true
      },
      {
        path: 'policyInterpretation/edit',
        component: () => import('@/views/cms/policyInterpretation/edit.vue'),
        name: 'PolicyInterpretationEdit',
        meta: {title: '编辑政策解读'},
        hidden: true
      }
    ],
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/advertise',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'advertise',
        component: () => import('@/views/sms/advertise/index.vue'),
        name: 'advertise',
        meta: {title: '广告管理'}
      },
      {
        path: 'advertise/add',
        component: () => import('@/views/sms/advertise/add.vue'),
        name: 'AdvertiseAdd',
        meta: {title: '添加广告'},
        hidden: true
      },
      {
        path: 'advertise/edit',
        component: () => import('@/views/sms/advertise/edit.vue'),
        name: 'AdvertiseEdit',
        meta: {title: '编辑广告'},
        hidden: true
      },
      {
        path: 'coupon',
        component: () => import('@/views/sms/coupon/index.vue'),
        name: 'coupon',
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'coupon/add',
        component: () => import('@/views/sms/coupon/add.vue'),
        name: 'CouponAdd',
        meta: {title: '添加优惠券'},
        hidden: true
      },
      {
        path: 'coupon/edit',
        component: () => import('@/views/sms/coupon/edit.vue'),
        name: 'CouponEdit',
        meta: {title: '编辑优惠券'},
        hidden: true
      },
      {
        path: 'dailyRecommendation',
        component: () => import('@/views/sms/dailyRecommendation/index'),
        name: 'dailyRecommendation',
        meta: { title: '每日推荐列表' }
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        component: () => import('@/views/oms/order/index.vue'),
        name: 'order',
        meta: {title: '订单列表', icon: 'oms-order'}
      },
      {
        path: 'orderDetail',
        component: () => import('@/views/oms/order/detail.vue'),
        name: 'orderDetail',
        meta: {title: '订单详情'},
        hidden: true
      },
      {
        path: 'orderSetting',
        component: () => import('@/views/oms/orderSetting/index.vue'),
        name: 'orderSetting',
        meta: {title: '订单列表', icon: 'oms-orderSetting'}
      },
      {
        path: 'refundApply',
        component: () => import('@/views/oms/refundApply/index.vue'),
        name: 'refundApply',
        meta: { title: '退款申请处理' }
      },
    ]
  },
  {
    path: '/cms',
    component: Layout,
    redirect: '/cms/course',
    name: 'cms',
    meta: {title: '课程', icon: 'cms'},
    children: [
      {
        path: 'course',
        component: () => import('@/views/cms/course/index.vue'),
        name: 'course',
        meta: {title: '课程列表', icon: 'cms-course'}
      },
      {
        path: 'course/add',
        component: () => import('@/views/cms/course/add.vue'),
        name: 'cmsCourseAdd',
        meta: {title: '添加课程'},
        hidden: true
      },
      {
        path: 'course/edit',
        component: () => import('@/views/cms/course/edit.vue'),
        name: 'cmsCourseEdit',
        meta: {title: '编辑课程'},
        hidden: true
      },
      {
        path: 'course/detail',
        component: () => import('@/views/cms/course/detail.vue'),
        name: 'cmsCourseDetail',
        meta: { title: '课程详情' },
        hidden: true
      },
      {
        path: 'course/teacherList',
        component: () => import('@/views/cms/course/teacherList.vue'),
        name: 'cmsCourseTeacherList',
        meta: {title: '讲师团队'},
        hidden: true
      },
      {
        path: 'courseCategory',
        component: () => import('@/views/cms/CourseCategory/index.vue'),
        name: 'courseCategory',
        meta: {title: '课程分类', icon: 'cms-category'}
      },
      {
        path: 'courseCategory/add',
        component: () => import('@/views/cms/CourseCategory/add.vue'),
        name: 'courseCategoryAdd',
        meta: {title: '添加分类'},
        hidden: true
      },
      {
        path: 'courseCategory/edit',
        component: () => import('@/views/cms/CourseCategory/edit.vue'),
        name: 'courseCategoryEdit',
        meta: {title: '编辑分类'},
        hidden: true
      },
      {
        path: 'courseCategory/courseList',
        component: () => import('@/views/cms/courseCategory/courseList.vue'),
        name: 'cmsCategoryCourseList',
        meta: { title: '课程分类关联课程' },
        hidden: true
      },
      {
        path: 'courseTag',
        component: () => import('@/views/cms/courseTag/index.vue'),
        name: 'courseTag',
        meta: {title: '课程标签', icon: 'cms-course-tag'}
      },
      {
        path: '/cms/courseTag/courseList',
        component: () => import('@/views/cms/courseTag/courseList.vue'),
        name: 'cmsTagCourseList',
        meta: { title: '课程标签关联课程' },
        hidden: true
      },
      {
        path: 'teacher',
        component: () => import('@/views/cms/teacher/index.vue'),
        name: 'cmsTeacher',
        meta: {title: '讲师管理', icon: 'cms-teacher'}
      },
      {
        path: 'course/outline',
        component: () => import('@/views/cms/course/outline.vue'),
        name: 'cmsCourseOutline',
        meta: { title: '课程大纲' },
        hidden: true
      },
      {
        path: 'location',
        component: () => import('@/views/cms/location/index.vue'),
        name: 'cmsLocation',
        meta: { title: '打卡地点管理', icon: 'cms-location' },
        hidden: true
      },
      {
        path: 'mediaResource',
        component: () => import('@/views/cms/mediaResource/index.vue'),
        name: 'cmsMediaResource',
        meta: {title: '资源管理', icon: 'cms-media'}
      },
      {
        path: 'mediaResource/add',
        component: () => import('@/views/cms/mediaResource/add.vue'),
        name: 'cmsMediaResourceAdd',
        meta: {title: '添加媒体资源'},
        hidden: true
      },
      {
        path: 'mediaResource/edit',
        component: () => import('@/views/cms/mediaResource/edit.vue'),
        name: 'cmsMediaResourceEdit',
        meta: {title: '编辑媒体资源'},
        hidden: true
      },
      {
        path: 'evaluation',
        component: () => import('@/views/cms/evaluation/index.vue'),
        name: 'cmsEvaluation',
        meta: {title: '评价管理', icon: 'cms-evaluation'},
        hidden: true
      },
    ]
  },
  {
    path: '/base',
    component: Layout,
    redirect: '/base/dictionary',
    name: 'base',
    meta: {title: '基础', icon: 'base'},
    children: [
      {
        path: 'dictionary',
        component: () => import('@/views/base/dictionary/index.vue'),
        name: 'dictionary',
        meta: {title: '数据字典'}
      },
      {
        path: 'dictionary/detail',
        component: () => import('@/views/base/dictionary/detail.vue'),
        name: 'dictionaryDetail',
        meta: {title: '数据字典详情'},
        hidden: true
      },
      {
        path: 'webLog',
        component: () => import('@/views/base/webLog/index.vue'),
        name: 'webLog',
        meta: {title: '操作日志'}
      },
      {
        path: 'adminLoginLog',
        component: () => import('@/views/base/adminLoginLog/index.vue'),
        name: 'adminLoginLog',
        meta: {title: '后台登录日志'}
      },
      {
        path: 'announcement',
        component: () => import('@/views/base/announcement/index.vue'),
        name: 'announcement',
        meta: {title: '系统公告'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js